/**
 * Ryan O'Dowd
 * 2025-05-15
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Image,
  View,
} from 'react-native';
import Dialog from '@components/common/Dialog';
import IconButton from '@components/common/IconButton';
import React from 'react';
import getStyles from './styles';
import hooks from '@hooks';

const Viewer = (props: ViewerProps) => {
  const styles = hooks.useStyles(getStyles);

  if (!props.visible) {
    return null;
  }

  return (
    <Dialog
      visible={true}
      onDismiss={() => props.onRequestClose()}
    >
      <Dialog.Title style={styles.title}>
        <View style={styles.closeButtonWrapper}>{/* @TODO: for some reason, can't apply these styles to Dialog.Title itself... */}
          <IconButton icon='close' size={styles.globalScale * 28} style={styles.closeButton} onPress={() => props.onRequestClose()} />
        </View>
      </Dialog.Title>
      <Dialog.Content style={styles.contentWrapper}>
        <Image
          style={styles.fullImage}
          source={props.image}
        />
      </Dialog.Content>
      <Dialog.Actions>
        {props.footerComponent}
      </Dialog.Actions>
    </Dialog>
  );
};

class ViewerProps {
  image: {};
  visible: boolean;
  onRequestClose: () => void;
  footerComponent: React.ReactElement;
};

export default Viewer;
